import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class RateLimitInterceptor implements HttpInterceptor {

  private lastToastTime = 0;
  private TOAST_GAP = 10000; // ms (20 second)

  constructor(private toastr: ToastrService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 429) {
          const now = Date.now();

          if (now - this.lastToastTime > this.TOAST_GAP) {
            this.lastToastTime = now;

            this.toastr.warning(
              error.error.message || "Too many requests. Please try again later.",
              'Rate limit exceeded', 
              {
                timeOut: 3000
              }
            );
          }
        }

        return throwError(() => error);
      })
    );
  }
}
